import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { Cctv, Smartphone, ArrowUpRight } from "lucide-react";
import { SIGNIN_URL } from "@/lib/marketing";

const OPTIONS = [
  { id: "cctv", icon: Cctv, label: "CCTV access", note: "Sign in to camera-based monitoring." },
  { id: "mobile", icon: Smartphone, label: "Mobile access", note: "Sign in from your phone." },
];

export const SignInDialog = ({ className = "" }) => (
  <Dialog>
    <DialogTrigger asChild>
      <button data-testid="nav-signin-button" className={`text-sm font-medium text-[#275C3F] border border-[#275C3F]/30 px-4 py-2 rounded-sm hover:bg-[#EAF0EA] transition-colors duration-200 ${className}`}>
        Sign in
      </button>
    </DialogTrigger>
    <DialogContent data-testid="signin-dialog" className="sm:max-w-md rounded-sm">
      <DialogHeader>
        <DialogTitle className="font-display">Sign in</DialogTitle>
        <DialogDescription>Choose how you want to sign in.</DialogDescription>
      </DialogHeader>
      <div className="grid gap-3 mt-2">
        {OPTIONS.map((o) => (
          <a key={o.id} href={SIGNIN_URL} target="_blank" rel="noopener noreferrer" data-testid={`signin-option-${o.id}`}
             className="group flex items-center gap-4 border border-[#DCE3DD] rounded-sm p-4 hover:border-[#275C3F] hover:bg-[#F8FAF8] transition-colors duration-200">
            <div className="h-10 w-10 grid place-items-center bg-[#EAF0EA] rounded-sm"><o.icon className="h-5 w-5 text-[#275C3F]" /></div>
            <div className="flex-1">
              <p className="font-semibold text-[#121A14]">{o.label}</p>
              <p className="text-xs text-[#4B5950] mt-0.5">{o.note}</p>
            </div>
            <ArrowUpRight className="h-4 w-4 text-[#4B5950] group-hover:text-[#275C3F]" />
          </a>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
